import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const Profiles = () => {
    const { data, isLoading } = useFetch('/api/maintenance/profiles/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'Id', accessor: 'id_perfil', Cell: renderCell },
                { Header: 'Perfil', accessor: 'perfil', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell },
            ];

            const rows = data.map((provider) => ({
                id_perfil: provider.id_perfil,
                perfil: provider.perfil,
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => {},
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nuevo Rol'
                dataTableData={dataTableData}
                hasFilters={false}
                getData={() => {}}
                CreateNewModal={() => {}}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />  
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Profiles;